import type { FunctionComponent } from "react";

 const EmptyFilterResultMessage: FunctionComponent<{ message?: string }> = ({ message }) => {
	return <tr>
		<td colSpan={100}
			className="whitespace-nowrap bg-inherit px-3 py-4 text-center text-gray-500">{message || "Keine Ergbenisse für die Filtereinstellungen gefunden."}
		</td>
	</tr>;
};


export default EmptyFilterResultMessage;